module.exports = __webpack_public_path__ + "img/sort-desc.b62f4651.svg";